/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import "./Tooltip.css";
const Tooltip = ({ testId, text, isVisible = true }) => {
  return (
    <div id="tooltip" data-testid={testId} className="on bottom">
      {isVisible && (
        <>
          <div className="tooltip-arrow"></div>
          <div className="tooltip-inner">{text}</div>
        </>
      )}
    </div>
  );
};
export default Tooltip;
